/* WORKDATA */
export const WORKDATA_LIST = 'WORKDATA_LIST';
export const WORKDATA_LIST_SUCCESS = 'WORKDATA_LIST_SUCCESS';
export const WORKDATA_LIST_FAILED = 'WORKDATA_LIST_FAILED';

export const WORKDATA_ADD = 'WORKDATA_ADD';
export const WORKDATA_ADD_SUCCESS = 'WORKDATA_ADD_SUCCESS';
export const WORKDATA_ADD_FAILED = 'WORKDATAADD_ADD_FAILED';

export const WORKDATA_UPDATE = 'WORKDATA_UPDATE';
export const WORKDATA_UPDATE_SUCCESS = 'WORKDATA_UPDATE_SUCCESS';
export const WORKDATA_UPDATE_FAILED = 'WORKDATA_UPDATE_FAILED';

export const WORKDATA_DELETE = 'WORKDATA_DELETE';
export const WORKDATA_DELETE_SUCCESS = 'WORKDATA_DELETE_SUCCESS';
export const WORKDATA_DELETE_FAILED = 'WORKDATAADD_DELETE_FAILED';
